export const APP_LOADED_SUBCRIBER = 'arcConfigLoaded';
export const ARC_CROSSSELL = 'crossSellData';
export const ARC_QUICKBET = 'QuickbetClose';
export const CROSSSELL_VALUES = ['Right-Column', 'crossSellData', 'mini-games'];
export const ARC_USER_CONSTANTS = ['Gaming cross sell removal', 'Quick bet removal', 'arcPrimaryReason', 'arcRiskBandLevel'];
